/**
 * A path into `public/` that resolves in BOTH places this bundle runs.
 *
 * On the web the app is BrowserRouter, so at /settings a bare
 * "vacars-logo.png" would resolve to /settings/vacars-logo.png. It has to be
 * root-relative there.
 *
 * In the desktop shell the page is file:///.../renderer/index.html, where a
 * LEADING SLASH resolves to the root of the drive — file:///vacars-logo.png.
 * The file is packaged correctly at /renderer/vacars-logo.png inside app.asar;
 * the reference was pointing somewhere else entirely, so the image rendered as
 * nothing, with no error and no log line.
 *
 * This is the same defect api.js documents for the API base ("a same-origin
 * /api resolves to file:///api"). That one was found and fixed; nothing else
 * beginning with a slash was checked. The logo and three rank insignia had it.
 *
 * Runtime, not REACT_APP_*: the same built bundle is served over https AND
 * loaded from disk, so a build-time constant cannot answer for both. Electron
 * uses HashRouter, so under file:// the document base stays index.html at
 * every route and "./" is always right.
 */
export function assetUrl(name) {
  const rel = String(name).replace(/^\/+/, "");
  const isFile = typeof window !== "undefined"
    && window.location
    && window.location.protocol === "file:";
  return isFile ? `./${rel}` : `/${rel}`;
}

// The 2026 VAC roundel, cropped from vac-logo-2026.png (the dispatcher
// dashboard's logo). Like the dispatcher, the app shows the mark beside a
// text title rather than a lettered image: the logo's white "VAC" vanishes on
// the light theme, and text follows the theme by itself. Self-hosted, never a
// CDN (an earlier logo was served from Emergent's).
export const VAC_MARK_URL = assetUrl("vac-mark.png");

export const APP_NAME = "FlyVAC";
export const APP_TAGLINE = "FlyVAC ACARS";

/** Operators supported for soundpack matching. Keep uppercase codes.
 *
 * Renamed to the divisional names 2026-09-24: Mainline, Express, Leisure,
 * Cargo. The CODES are deliberately unchanged — a code is the soundpack
 * matching key (`/sounds/packs/for-operator/{code}`) and is stored in
 * `soundpacks.operator`, so renaming one would orphan every pack already
 * uploaded under it. Only the display strings moved.
 *
 * "Air Canada" still means the virtual airline itself elsewhere — the theme,
 * the logo, the README. These are its operating divisions, which is a
 * different thing, and why the rename stops here.
 *
 * Keep in step with OPERATOR_NAMES in backend/fleet_file.py. */
export const OPERATORS = [
  { code: "AC", name: "Mainline" },
  { code: "QK", name: "Express" },
  { code: "RV", name: "Leisure" },
  { code: "AK", name: "Cargo" },
  { code: "OTHER", name: "Other / Charter" },
];
